module.exports = "/images/example_case_1.png?a4edcb12e782bbca909bfdd6ca81ad89";